import { pxToRem } from '@deltek/specification-client/core/Utilities/unitUtils'
import Button from '@material-ui/core/Button'
import { makeStyles } from '@material-ui/core/styles'
import clsx from 'clsx'
import React, { FC, ReactNode } from 'react'
import {
    advancedFilterDefaultColor,
    advancedFilterDefaultHoveredColor,
} from 'shared/common/productListingDialogColors'

const useStyles = makeStyles((theme) => ({
    buttonCommon: {
        borderRadius: theme.spacing(2.5),
        fontSize: pxToRem(16),
        lineHeight: 1.43,
        padding: '5px 15px',
        whiteSpace: 'nowrap',
        cursor: 'pointer',
        margin: theme.spacing(1, 1),
    },
    buttonActive: {
        color: theme.palette.common.white,
        backgroundColor: advancedFilterDefaultColor,
        '&:hover': {
            backgroundColor: advancedFilterDefaultHoveredColor,
        },
    },
    buttonInactive: {
        color: advancedFilterDefaultColor,
        borderColor: advancedFilterDefaultColor,
    },
}))

const FilterPills: FC<{
    buttonText: ReactNode
    handleClick: (prop?: any) => void
    isActive: boolean
    testid?: string
    disabled?: boolean
}> = ({ buttonText, handleClick, isActive, testid, disabled = false }) => {
    const classes = useStyles()

    return (
        <Button
            data-testid={testid ?? `filterPillButton_${buttonText}`}
            variant="outlined"
            onClick={handleClick}
            className={clsx(
                classes.buttonCommon,
                !!isActive ? classes.buttonActive : classes.buttonInactive
            )}
            disabled={disabled}
        >
            {buttonText}
        </Button>
    )
}

export default FilterPills
